<template>
  <div class='flex flex-col overflow-y-auto'>
    <div v-for="(cp, index) in activeOfflineConsults" :key="index" @click="selectFromConnectedList(cp.channelId)" 
    :class="(cp.channelId === activeCustomer) ? 'bg-grey-extralight': ''" 
    class="flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest justify-center hover:bg-grey-extralight cursor-pointer">
      <div class="flex flex-row items-center h-4 mb-2">
        <div class="text-m font-semibold text-grey-darkest capitalize">{{cp.name ? cp.name : 'No Name'}}</div>
        <div v-if="cp.channelId === activeCustomer" title="View Profile" v-on:click="viewCustomerProfile($event)" 
        class="text-blue hover:text-white hover:bg-blue h-6 w-6 items-center rounded-full flex flex-col self-center justify-center ml-1">
          <i class="far fa-user fa-xs"></i>
        </div>
        
        <div class="flex m-1 ml-auto" v-if="cp.isFamilyDoctor"><img src="../../assets/personal_patient.svg" alt="Personal Patient" style="width:20px; height:20px"></div>
      </div>
      <div class="flex flex-row text-grey-dark h-4 text-xs">
        <div class="flex self-center">{{cp.channelId}}</div>
        <div class="flex ml-auto">
          <div v-if="cp.channelId === activeCustomer" title="End Chat" v-on:click="endConsultation($event, 'endChatClicked')" class="hover:bg-green hover:text-white flex flex-col self-center justify-center mr-2 ml-auto items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-grey"><i class="fa fa-xs pl-1 fa-check"></i></div>
        <div v-if="cp.channelId === activeCustomer" title="Incomplete Chat" v-on:click="endConsultation($event, 'incompleteChatClicked')" class="hover:bg-red hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-grey"><i class="fa fa-xs pl-1 fa-times"></i></div>
        </div>
      </div>
    </div>
    <!-- show customer profile -->
    <customer-profile v-if="viewProfile" @viewCustomerProfile="viewCustomerProfile" />
    <!--End Chat confirmation Popup -->
    <div v-if="endChatClicked || incompleteChatClicked">
      <div id="overlay" @click="closeEndChatOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <!--VALID Confirmation pop up when ending consultation-->
      <div v-if="endChatClicked" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
              <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> Ending this consultation as valid</div>
                  <img @click="closeEndChatOverlay()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
              </div>
              <label class="text-grey-darker font-light text-xs">Are you sure you want to end this consult?</label>
              <div class="flex flex-row mt-3 mb-2 justify-start">
                  <div v-on:click="endChat('SUCCESS')" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Yes</div>
                  <div v-on:click="closeEndChatOverlay()" class="flex flex-col bg-grey-lightest ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md">No</div>
              </div>
          </div>
      </div>
      <!--INVALID Confirmation pop up when ending consultation-->
      <div v-if="incompleteChatClicked" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;"> <!--display none-->
          <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
              <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> Ending this consultation as invalid</div>
                  <img @click="closeEndChatOverlay()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
              </div>
              <label class="text-grey-darker font-light text-xs">Reason for ending the consult as invalid</label>
              <div @input="reasonInput($event)" id="editor" contenteditable="true" class="border border-grey-lightest text-grey-darker text-sm border-solid rounded-sm px-1 py-2 my-2 focus:border-blue" style="outline: none; max-height: 150px; overflow-y: auto"></div>
              <div class="flex flex-row mt-3 mb-2 justify-between">
                  <div class="text-xs text-grey-darker self-center"></div>
                  <div v-on:click="endChat('FAILURE')" class="flex flex-col bg-blue px-4 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Submit</div>
              </div>
          </div>
      </div>
    </div>
  <!-- END  -->
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import CustomerProfile from '@/components/Customer/CustomerProfile'
export default {
  components: {
    CustomerProfile
  },
  data () {
    return {
      endChatClicked: false,
      incompleteChatClicked: false,
      viewProfile: false,
      reasons: null
    }
  },
  computed: {
    ...mapState({
      activeOfflineConsults: state => state.offlineConsultation.activeOfflineConsults,
      activeCustomer: state => state.offlineConsultation.activeCustomerId
    }),
    ...mapGetters({

    })
  },
  methods: {
    selectFromConnectedList: function (customerId) {
      this.$store.dispatch('offlineConsultation/switchTo', customerId)
    },
    endChat: function (status) {
      this.$store.dispatch('offlineConsultation/endConsultation', {status: status, reasons: this.reasons})
      this.closeEndChatOverlay()
    },
    endConsultation: function (e, item) {
      this[item] = true
      e.stopPropagation()
    },
    closeEndChatOverlay: function () {
      this.endChatClicked = false
      this.incompleteChatClicked = false
    },
    viewCustomerProfile: function (e) {
      e.stopPropagation()
      this.viewProfile = !this.viewProfile
    },
    reasonInput: function (e) {
      this.reasons = document.getElementById('editor').innerText
    }
  }
}
</script>

<style>
.patientActive {
  background-color: #dae1e76e

}

</style>



// WEBPACK FOOTER //
// src/components/OfflineConsultations/ActiveOfflineConsultations.vue